var map = {
	"./whitecamera.png": 9389,
	"./whiteequalizer.png": 4857,
	"./whiteharvest.png": 7331,
	"./whiteplant.png": 1180,
	"./whitesettings.png": 82,
	"./whitestatus.png": 4562
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5189;